//--------------------------------------------------------------
// Вставляет кнопку доната
// вызывать <div id="donate-button" data-small-size=true data-random=70 data-button-text="Стать частью идеала"></div>
// id="donate-button" - по id находится блок куда вставлять
// data-button-text   - Набпись на кнопке
// data-small-size    - true значит картинки под кпокой, крипту не показываем
// data-random        - верояность показа от 0 до 100%, если не указано показывается всегда
//--------------------------------------------------------------
class DonateForm {
	static url   = 'https://mobile-app.pumb.ua/9U869Tp3rDBnrXtK8';
	static ppurl = 'https://www.paypal.com/donate/?hosted_button_id=V2VKCFGSJPGPU';
	constructor() {
	  window.copyToClipboard = this.copyToClipboard.bind(this); // Добавляем в глобальную область
	  document.querySelectorAll(".donate-button").forEach(container => {
		const htmlContent = this.generateHTML(container);
		if (htmlContent == null) {
			container.remove();
		} else {
		  container.innerHTML = htmlContent;
		}
	  });
		// Добавляем стили (динамически)
	  const styleTag = document.createElement("style");
		styleTag.textContent = this.generateStyle();
		document.head.appendChild(styleTag);
	}
	
	copyToClipboard(element) {
	  const originalText = element.innerHTML;
	  navigator.clipboard.writeText(originalText)
	  .then(() => {
		element.innerHTML = '✓ Скопировано!';
		setTimeout(() => element.innerHTML = originalText, 2000);
	  })
	  .catch(console.error);
	}
	
	generateHTML(container) {
	  // Если контейнер есть — вставляем форму
		const buttonText = container.dataset.buttonText || "Поддержать проект";
		const smallSize = (container.dataset.smallSize == 'true');
		const isRender = container.dataset.random ? (Math.random() * 100 > (100 - Number(container.dataset.random))) : true;
  
		const payIcons = `
			  <span class="visa-icon">
				  <!-- SVG Visa -->
				  <svg width="2rem" height="2rem" viewBox="0 -11 70 70" fill="none" xmlns="http://www.w3.org/2000/svg">
					  <rect x="0.5" y="0.5" width="69" height="47" rx="5.5" fill="white" stroke="#D9D9D9"/>
					  <path fill-rule="evenodd" clip-rule="evenodd" d="M21.2505 32.5165H17.0099L13.8299 20.3847C13.679 19.8267 13.3585 19.3333 12.8871 19.1008C11.7106 18.5165 10.4142 18.0514 9 17.8169V17.3498H15.8313C16.7742 17.3498 17.4813 18.0514 17.5991 18.8663L19.2491 27.6173L23.4877 17.3498H27.6104L21.2505 32.5165ZM29.9675 32.5165H25.9626L29.2604 17.3498H33.2653L29.9675 32.5165ZM38.4467 21.5514C38.5646 20.7346 39.2717 20.2675 40.0967 20.2675C41.3931 20.1502 42.8052 20.3848 43.9838 20.9671L44.6909 17.7016C43.5123 17.2345 42.216 17 41.0395 17C37.1524 17 34.3239 19.1008 34.3239 22.0165C34.3239 24.2346 36.3274 25.3992 37.7417 26.1008C39.2717 26.8004 39.861 27.2675 39.7431 27.9671C39.7431 29.0165 38.5646 29.4836 37.3881 29.4836C35.9739 29.4836 34.5596 29.1338 33.2653 28.5494L32.5582 31.8169C33.9724 32.3992 35.5025 32.6338 36.9167 32.6338C41.2752 32.749 43.9838 30.6502 43.9838 27.5C43.9838 23.5329 38.4467 23.3004 38.4467 21.5514ZM58 32.5165L54.82 17.3498H51.4044C50.6972 17.3498 49.9901 17.8169 49.7544 18.5165L43.8659 32.5165H47.9887L48.8116 30.3004H53.8772L54.3486 32.5165H58ZM51.9936 21.4342L53.1701 27.1502H49.8723L51.9936 21.4342Z" fill="#172B85"/>
					  </svg>
				</span>
				<span class="mastercard-icon">
				  <!-- SVG Mastercard -->
				  <svg width="2rem" height="2rem" viewBox="0 -11 70 70" fill="none" xmlns="http://www.w3.org/2000/svg">
					  <rect x="0.5" y="0.5" width="69" height="47" rx="5.5" fill="white" stroke="#D9D9D9"/>
					  <path fill-rule="evenodd" clip-rule="evenodd" d="M35.3945 34.7619C33.0114 36.8184 29.92 38.0599 26.5421 38.0599C19.0047 38.0599 12.8945 31.8788 12.8945 24.254C12.8945 16.6291 19.0047 10.448 26.5421 10.448C29.92 10.448 33.0114 11.6895 35.3945 13.7461C37.7777 11.6895 40.869 10.448 44.247 10.448C51.7843 10.448 57.8945 16.6291 57.8945 24.254C57.8945 31.8788 51.7843 38.0599 44.247 38.0599C40.869 38.0599 37.7777 36.8184 35.3945 34.7619Z" fill="#ED0006"/>
					  <path fill-rule="evenodd" clip-rule="evenodd" d="M35.3945 34.7619C38.3289 32.2296 40.1896 28.4616 40.1896 24.254C40.1896 20.0463 38.3289 16.2783 35.3945 13.7461C37.7777 11.6895 40.869 10.448 44.247 10.448C51.7843 10.448 57.8945 16.6291 57.8945 24.254C57.8945 31.8788 51.7843 38.0599 44.247 38.0599C40.869 38.0599 37.7777 36.8184 35.3945 34.7619Z" fill="#F9A000"/>
					  <path fill-rule="evenodd" clip-rule="evenodd" d="M35.3946 13.7461C38.329 16.2784 40.1897 20.0463 40.1897 24.254C40.1897 28.4616 38.329 32.2295 35.3946 34.7618C32.4603 32.2295 30.5996 28.4616 30.5996 24.254C30.5996 20.0463 32.4603 16.2784 35.3946 13.7461Z" fill="#FF5E00"/>
				  </svg>
				</span>
				<span class="applepay-icon">
				  <svg width="2rem" height="2rem" viewBox="0 -11 70 70" fill="none" xmlns="http://www.w3.org/2000/svg">
					  <rect x="0.5" y="0.5" width="69" height="47" rx="5.5" fill="white" stroke="#D9D9D9"/>
					  <path fill-rule="evenodd" clip-rule="evenodd" d="M19.1601 16.6863C18.5726 17.3901 17.6325 17.9452 16.6924 17.8659C16.5749 16.9143 17.0352 15.9032 17.5737 15.2787C18.1613 14.5551 19.1895 14.0397 20.0219 14C20.1198 14.9913 19.7379 15.9627 19.1601 16.6863ZM20.012 18.0542C19.1838 18.006 18.4281 18.3064 17.8177 18.549C17.4249 18.7051 17.0923 18.8373 16.8392 18.8373C16.5552 18.8373 16.2089 18.6981 15.82 18.5417L15.82 18.5417L15.82 18.5417L15.82 18.5417C15.3104 18.3368 14.7278 18.1025 14.1169 18.1137C12.7166 18.1335 11.4142 18.9365 10.6993 20.2152C9.23044 22.7726 10.3174 26.5593 11.7373 28.6409C12.4326 29.6718 13.265 30.8018 14.3617 30.7622C14.8442 30.7438 15.1913 30.5947 15.5505 30.4404C15.9641 30.2628 16.3937 30.0782 17.0645 30.0782C17.712 30.0782 18.1228 30.2579 18.5172 30.4305C18.8921 30.5945 19.2522 30.752 19.7868 30.7424C20.9227 30.7225 21.6376 29.7115 22.3328 28.6806C23.0831 27.5741 23.4129 26.4943 23.4629 26.3304L23.4688 26.3114C23.4676 26.3102 23.4583 26.3059 23.4419 26.2984C23.1911 26.1821 21.274 25.2937 21.2557 22.9114C21.2372 20.9118 22.7762 19.8987 23.0185 19.7392C23.0332 19.7295 23.0432 19.723 23.0477 19.7196C22.0684 18.2525 20.5408 18.0939 20.012 18.0542ZM27.8755 30.6333V15.1796H33.6041C36.5615 15.1796 38.6277 17.2414 38.6277 20.2548C38.6277 23.2683 36.5223 25.3499 33.5258 25.3499H30.2453V30.6333H27.8755ZM30.2451 17.2018H32.9772C35.0336 17.2018 36.2087 18.312 36.2087 20.2648C36.2087 22.2175 35.0336 23.3377 32.9674 23.3377H30.2451V17.2018ZM46.452 28.7797C45.8253 29.989 44.4445 30.7523 42.9561 30.7523C40.7527 30.7523 39.2153 29.424 39.2153 27.4217C39.2153 25.4391 40.7038 24.2992 43.4555 24.1307L46.4128 23.9522V23.0998C46.4128 21.8409 45.6 21.1569 44.1508 21.1569C42.9561 21.1569 42.0845 21.7814 41.9083 22.733H39.7735C39.842 20.7307 41.7026 19.2735 44.2193 19.2735C46.9318 19.2735 48.6945 20.7108 48.6945 22.9412V30.6333H46.501V28.7797H46.452ZM43.5924 28.9185C42.3292 28.9185 41.5262 28.3039 41.5262 27.3622C41.5262 26.3908 42.2998 25.8257 43.7785 25.7365L46.4127 25.568V26.4403C46.4127 27.8876 45.1984 28.9185 43.5924 28.9185ZM55.9702 31.238C55.0204 33.9442 53.9334 34.8363 51.6224 34.8363C51.4461 34.8363 50.8585 34.8165 50.7214 34.7768V32.9232C50.8683 32.943 51.2307 32.9628 51.4167 32.9628C52.4645 32.9628 53.0521 32.5167 53.4144 31.357L53.6298 30.673L49.6149 19.4222H52.0924L54.8833 28.5517H54.9322L57.7231 19.4222H60.1321L55.9702 31.238Z" fill="#000000"/>
				  </svg>
				</span>
				<span class="gpay-icon">
				  <svg width="2rem" height="2rem" viewBox="0 -11 70 70" fill="none" xmlns="http://www.w3.org/2000/svg">
					  <rect x="0.5" y="0.5" width="69" height="47" rx="5.5" fill="white" stroke="#D9D9D9"/>
					  <path fill-rule="evenodd" clip-rule="evenodd" d="M33.0603 31.5161V25.4741H36.1786C37.4564 25.4741 38.535 25.046 39.4142 24.2015L39.6252 23.9875C41.2313 22.2391 41.1258 19.5155 39.4142 17.898C38.5584 17.0416 37.3861 16.5778 36.1786 16.6016H31.1729V31.5161H33.0603ZM33.0605 23.6425V18.4332H36.2262C36.9063 18.4332 37.5512 18.6948 38.0319 19.1706C39.052 20.1696 39.0754 21.8347 38.0905 22.8694C37.6098 23.3809 36.9297 23.6663 36.2262 23.6425H33.0605ZM48.4293 22.1083C47.6204 21.359 46.5185 20.9784 45.1234 20.9784C43.3298 20.9784 41.9816 21.6444 41.0906 22.9646L42.7553 24.0231C43.3649 23.1192 44.1973 22.6673 45.2524 22.6673C45.9206 22.6673 46.5653 22.9171 47.0694 23.369C47.5618 23.7972 47.8432 24.4156 47.8432 25.0698V25.5098C47.1163 25.1055 46.2019 24.8914 45.0765 24.8914C43.7635 24.8914 42.7084 25.2006 41.923 25.831C41.1375 26.4613 40.739 27.2939 40.739 28.3524C40.7155 29.3158 41.1258 30.2316 41.8527 30.85C42.5912 31.5161 43.5291 31.8491 44.631 31.8491C45.9323 31.8491 46.9639 31.2663 47.7494 30.1007H47.8314V31.5161H49.6368V25.2244C49.6368 23.9042 49.2382 22.8576 48.4293 22.1083ZM43.3066 29.6369C42.9197 29.3514 42.6852 28.8876 42.6852 28.3881C42.6852 27.8291 42.9432 27.3652 43.4473 26.9965C43.9632 26.6278 44.6081 26.4375 45.3702 26.4375C46.4255 26.4256 47.2462 26.6635 47.8325 27.1392C47.8325 27.948 47.5159 28.6497 46.8945 29.2444C46.3317 29.8153 45.5696 30.1364 44.7723 30.1364C44.2446 30.1483 43.7287 29.9699 43.3066 29.6369ZM53.693 35.9999L60.0001 21.3114H57.9485L55.0295 28.6378H54.9943L52.0049 21.3114H49.9534L54.0916 30.8619L51.747 35.9999H53.693Z" fill="#3C4043"/>
					  <path d="M26.544 24.1659C26.544 23.5831 26.4971 23.0003 26.4034 22.4294H18.4434V25.7239H23.0037C22.8161 26.7825 22.2065 27.734 21.3155 28.3286V30.4695H24.0353C25.6296 28.9828 26.544 26.7825 26.544 24.1659Z" fill="#4285F4"/>
					  <path d="M18.4442 32.539C20.7185 32.539 22.6411 31.7778 24.0361 30.4695L21.3164 28.3287C20.5544 28.852 19.5814 29.1493 18.4442 29.1493C16.2403 29.1493 14.3763 27.6388 13.7081 25.6169H10.9062V27.8291C12.3365 30.7193 15.2555 32.539 18.4442 32.539Z" fill="#34A853"/>
					  <path d="M13.708 25.6169C13.3563 24.5584 13.3563 23.4048 13.708 22.3343V20.134H10.9058C9.69808 22.5484 9.69808 25.4029 10.9058 27.8172L13.708 25.6169Z" fill="#FBBC04"/>
					  <path d="M18.4442 18.8019C19.6517 18.7781 20.8123 19.242 21.6798 20.0864L24.0948 17.6363C22.559 16.1853 20.5427 15.3885 18.4442 15.4123C15.2555 15.4123 12.3365 17.2439 10.9062 20.134L13.7081 22.3462C14.3763 20.3124 16.2403 18.8019 18.4442 18.8019Z" fill="#EA4335"/>
				  </svg>
				</span>`;
	  
	  const cryptAdd = smallSize ? '' : `
		  <div><a class="tiny-text crypto" onclick="document.getElementById('btc').setAttribute('open', '')">если "все бабки в крипте и на картах пусто"</a></div>
	  
		  <dialog id="btc" class="small-text btc"> 
			  <article>
				  <header><button aria-label="Close" rel="prev" onclick="document.getElementById('btc').removeAttribute('open', '')"></button>
					<h5>Мы принимаем донаты и в криптовалюте</h5>
				  </header>
				  <ul>
					  <li>Bitcoin отправляйте по BTC: <a onclick="copyToClipboard(this)">1LNa6ovzPfbJeceSLes9RQsUXfiw6xiHiV</a></li>
					  <li>USDT по сети:
						  <ul style="margin-bottom: 0 ;">
							  <li>TRC20: <a onclick="copyToClipboard(this)">TWstKiGEfrAxMxDpB4wp3QobLmXSW6RqWo</a></li>
							  <li>BEP20: <a onclick="copyToClipboard(this)">0xea087b34d200516afbddc25b654721c24bdfd42c</a></li>
							  <li>ERC20: <a onclick="copyToClipboard(this)">0xea087b34d200516afbddc25b654721c24bdfd42c</a></li>
						  </ul>
					  </li>
					  <li>Ethereum: <a onclick="copyToClipboard(this)">0xea087b34d200516afbddc25b654721c24bdfd42c</a></li>
					  <li>Solana: <a onclick="copyToClipboard(this)">8eMKpofvp8vUSoXxpLgQyApfgmWRt9DfbX22UWtarcNR</a></li>
					  <li>Tron: <a onclick="copyToClipboard(this)">TWstKiGEfrAxMxDpB4wp3QobLmXSW6RqWo</a></li>
					  <li>Binance pay id: <a onclick="copyToClipboard(this)">428241178</a></li>
				  </ul>
				  <footer>
					  Спасибо что учавствуете в развитии нашего проекта.
				  </div>
			  </article>
		  </dialog>		
	  ` ;
		
	  const r1 = smallSize ? '' : payIcons;
	  const r2 = smallSize ? ('<div>'+payIcons+'</div>') : '';
	  const r3 = smallSize ? '' : 'Donate';
	  
	  
	  return isRender ? `
		  <div class="btn_group">
		  <a role="button" data-tooltip="Поддержать проект через украинский банк." class="pay-btn" href="${DonateForm.url}" target="_blank">
			  <span class="pay-label">${buttonText}</span>
			  ${r1}
		  </a>
		  <a role="button" data-tooltip="PayPal - The safer, easier way to pay online!" class="pp-btn" href="${DonateForm.ppurl}" target="_blank">
			  <span style="padding-left: 1rem;">
				  <svg width="1.3rem" height="1.3rem"  viewBox="0 0 128 128" xmlns="http://www.w3.org/2000/svg">
					  <path d="M90.35,16.05c-11.66,0-21.81,6.97-26.35,17.06c-4.54-10.08-14.69-17.06-26.35-17.06 c-15.92,0-28.87,12.96-28.87,28.88c0,35.9,51.79,65.46,54,66.7c0.38,0.21,0.79,0.32,1.21,0.32c0.42,0,0.84-0.11,1.21-0.32 c2.2-1.24,54.01-30.8,54.01-66.7C119.22,29.01,106.27,16.05,90.35,16.05z" style="fill:#DB4437;"/>
				  </svg>
			  </span>
			  <span>${r3} with&nbsp;</span>
			  <span style="padding-right: 1rem;">			
				<svg height="1.5rem" xmlns="http://www.w3.org/000/svg" fill="none" viewBox="45 2 130 48">
				  <path fill="#003087" d="M62.56 28.672a10.111 10.111 0 0 0 9.983-8.56c.78-4.967-3.101-9.303-8.6-9.303H55.08a.689.689 0 0 0-.69.585l-3.95 25.072a.643.643 0 0 0 .634.742h4.69a.689.689 0 0 0 .688-.585l1.162-7.365a.689.689 0 0 1 .689-.586h4.257Zm3.925-8.786c-.29 1.836-1.709 3.189-4.425 3.189h-3.474l1.053-6.68h3.411c2.81.006 3.723 1.663 3.435 3.496v-.005Zm26.378-1.18H88.41a.69.69 0 0 0-.69.585l-.144.924s-3.457-3.775-9.575-1.225c-3.51 1.461-5.194 4.48-5.91 6.69 0 0-2.277 6.718 2.87 10.417 0 0 4.771 3.556 10.145-.22l-.093.589a.642.642 0 0 0 .634.742h4.451a.689.689 0 0 0 .69-.585l2.708-17.175a.643.643 0 0 0-.634-.742Zm-6.547 9.492a4.996 4.996 0 0 1-4.996 4.276 4.513 4.513 0 0 1-1.397-.205c-1.92-.616-3.015-2.462-2.7-4.462a4.996 4.996 0 0 1 5.014-4.277c.474-.005.946.065 1.398.206 1.913.614 3.001 2.46 2.686 4.462h-.005Z"/>
				  <path fill="#0070E0" d="M126.672 28.672a10.115 10.115 0 0 0 9.992-8.56c.779-4.967-3.101-9.303-8.602-9.303h-8.86a.69.69 0 0 0-.689.585l-3.962 25.079a.637.637 0 0 0 .365.683.64.64 0 0 0 .269.06h4.691a.69.69 0 0 0 .689-.586l1.163-7.365a.688.688 0 0 1 .689-.586l4.255-.007Zm3.925-8.786c-.29 1.836-1.709 3.189-4.426 3.189h-3.473l1.054-6.68h3.411c2.808.006 3.723 1.663 3.434 3.496v-.005Zm26.377-1.18h-4.448a.69.69 0 0 0-.689.585l-.146.924s-3.456-3.775-9.574-1.225c-3.509 1.461-5.194 4.48-5.911 6.69 0 0-2.276 6.718 2.87 10.417 0 0 4.772 3.556 10.146-.22l-.093.589a.637.637 0 0 0 .365.683c.084.04.176.06.269.06h4.451a.686.686 0 0 0 .689-.586l2.709-17.175a.657.657 0 0 0-.148-.518.632.632 0 0 0-.49-.224Zm-6.546 9.492a4.986 4.986 0 0 1-4.996 4.276 4.513 4.513 0 0 1-1.399-.205c-1.921-.616-3.017-2.462-2.702-4.462a4.996 4.996 0 0 1 4.996-4.277c.475-.005.947.064 1.399.206 1.933.614 3.024 2.46 2.707 4.462h-.005Z"/>
				  <path fill="#003087" d="m109.205 19.131-5.367 9.059-2.723-8.992a.69.69 0 0 0-.664-.492h-4.842a.516.516 0 0 0-.496.689l4.88 15.146-4.413 7.138a.517.517 0 0 0 .442.794h5.217a.858.858 0 0 0 .741-.418l13.632-22.552a.516.516 0 0 0-.446-.789h-5.215a.858.858 0 0 0-.746.417Z"/>
				  <path fill="#0070E0" d="m161.982 11.387-3.962 25.079a.637.637 0 0 0 .365.683c.084.04.176.06.269.06h4.689a.688.688 0 0 0 .689-.586l3.963-25.079a.637.637 0 0 0-.146-.517.645.645 0 0 0-.488-.225h-4.69a.69.69 0 0 0-.689.585Z"/>
				</svg>
			  </span>
		  </a>
		  </div>
		  ${r2}
		  ${cryptAdd}` : null;
	}
	
	generateStyle() {
	  return `
		  .pay-label {
			  padding-right: 1.6rem;
			  padding-left: 1.6rem;
			  min-height: 1.5rem;
		  }
  
		  .pay-btn {
			  min-height: 2.35rem;
			  background: linear-gradient(-45deg, #518f65, #e6ab54, #23a6d5, #23d5ab);
			  background-size: 400% 400%;
			  animation: gradient 15s ease infinite;
			  border: 0;    
			  box-shadow: 0 4px 8px rgba(0,0,0,0.2);;
			  padding: 0.4rem;
			  border-radius: 0.55rem;
		  }
		  
		  .pp-btn {
			  min-height: 2.35rem;
			  background: linear-gradient(-45deg, #fbfbfb, #ededed ,#f9f9f9, #ffffff);
			  background-size: 200% 400%;
			  animation: gradient 15s ease infinite;
			  border: 0;    
			  box-shadow: 0 4px 8px rgba(0,0,0,0.2);;
			  padding: 0.4rem;
			  border-radius: 0.55rem;
			  color: black;
			  font-weight: bold;
		  }
		  
		  .btn_group {
			  margin-top: 1.2rem;
			  display: flex; gap: 1rem;
			  justify-content: center;
			  align-items: center;
		  }
  
		  .btc article {
			  max-width: 34rem; 
			  padding-bottom: 1.5rem;
			  border-radius: 0.55rem;
			  text-align: left;
		  }
  
		  .btc header {
			  margin-bottom: 1rem;
			  padding-bottom: 1rem;
			  padding-top: 1.2rem;
			  background: linear-gradient(-45deg, #518f65, #e6ab54, #23a6d5, #23d5ab);
			  background-size: 400% 400%;
			  animation: gradient 15s ease infinite;		
		  }
		  
		  .btc [rel=prev] {
			  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none' stroke='rgb(245, 245, 245)' stroke-width='3' stroke-linecap='round' stroke-linejoin='round'%3E%3Cline x1='18' y1='6' x2='6' y2='18'%3E%3C/line%3E%3Cline x1='6' y1='6' x2='18' y2='18'%3E%3C/line%3E%3C/svg%3E");
		  }
  
		  .btc header h5 {
			  color: white !important;
			  margin-left: 1rem;
		  }
  
		  .btc footer {
			  margin-top: 0;
			  margin-bottom: 0;
			  padding-bottom: 0;
			  padding-top: 1rem;
		  }
  
		  .btc ul li{
			  list-style: inherit;
			  margin-left: -0.5rem;
		  }
		` ;
	}
  }
  
  new DonateForm();